module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAAGElEQVR4AWMYtOA/HggHDXggBWDUTQMPACXhPtdFrqHzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/featured/icons/menu.png
// module id = 713
// module chunks = 0